import React from 'react'
import { Table, Space, Button, Tooltip, Popconfirm, Image } from 'antd'
import { RedoOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import Config from '../../config'
import PetProfileImage from '../../assets/images/pet-profile-pic.svg'

type PetRestoreListProps = BaseListComponentProps & {
  shelterUuid: string,
  loading: boolean,
  pets: any,
  pagination: any,

  loadPets: (args: SearchRequest) => void,

  onRestore: (petUuid: string[]) => void
}

export default class PetRestoreList extends ListComponent<PetRestoreListProps> {

  static defaultProps = {
    loading: false,
    pets: [],

    loadPets: () => {},
    onRestore: () => {}
  }

  tableColumns = [
    {
      title: 'Image',
      dataIndex: 'picture',
      key: 'picture',
      responsive: ['md'] as any,
      render: (text: string, record: any) => (
        <Image
          src={record.picture ? `${Config.cdnImagesBase}organization/pet/picture/AUTOx32/${record.picture}` : PetProfileImage}
          fallback={PetProfileImage}
          width={32}
        />
      )
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'Location',
      dataIndex: ['branch', 'name'],
      key: 'branch',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.branch?.name - b.branch?.name
    },
    {
      title: 'Custom Code',
      dataIndex: 'custom_code',
      key: 'custom_code',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.custom_code - b.custom_code
    },
    {
      title: 'Global Code',
      dataIndex: 'global_code',
      key: 'global_code',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.global_code - b.global_code
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size="middle">
          <div ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Tooltip placement="left" title="Restore">
              <Popconfirm
                placement="topRight"
                title="Are you sure about restoring this pet?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => this.handleRestoreOne(record.uuid)}
              >
                <Button type="dashed" shape="round" icon={<RedoOutlined />} />
              </Popconfirm>
            </Tooltip>
          </div>
        </Space>
      )
    }
  ]

  componentDidMount() {
    this.searchOptions.search = {
      ...this.searchOptions.search,
      deleted: true,
      branch: {
        with: {
          _exists: true,
          shelter: {
            with: {
              _exists: true,
              uuid: this.props.shelterUuid
            }
          }
        }
      }
    }
    this.searchOptions.options = {
      ...this.searchOptions.options,
      _force_ids: true
    }

    this.props.loadPets(this.searchOptions)
  }

  handleRestoreOne = (petUuid: string) => {
    this.props.onRestore([petUuid])
  }

  render() {
    const { loading, pagination, pets, loadPets } = this.props

    let paginationOptions = {}
    if (pagination) {
      paginationOptions = {
        total: pagination.count,
        pageSize: pagination.limit,
        current: pagination.page
      }
    }

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={paginationOptions}
          dataSource={pets}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadPets)}
        />
      </>
    )
  }
}
